module.exports = __webpack_public_path__ + "media/UI叮咚音效_同学动态-高品质.403e22ae.wav";